import axios from "axios";
import { API_URL, FOLDERPATH } from "../Constants/config";
import { toast } from "react-toastify";
import { AUTO_LOGIN_LOADING, AUTO_LOGIN_SUCCESS, AUTO_LOGIN_FAILED } from "../Constants/autoLoginConstants";
import { handleApiError } from "../Helper/actionHelper";

export const getAutoLogin = () => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  

    dispatch({ type: AUTO_LOGIN_LOADING });

    const requestData = { 
      token:
      userLocalData.id,
      // "group": 10,
      //"referenceNo": "291664450159",
    };

    //return false;
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    //axios.defaults.baseURL = API_URL;
    const { data } = await axios.post(FOLDERPATH +
      "/ClientApi/autoLoginCandidate", 
      requestData,
      {
     headers: headers,
      }
    );

    dispatch({
      type: AUTO_LOGIN_SUCCESS,
      payload: data,
    });

    const obj={};
    obj.loading=false;
    obj.autoLoginData=data;
     localStorage.setItem("autoLogin", JSON.stringify(data));

    handleApiError(data);

  } catch (error) {
    dispatch({
      type: AUTO_LOGIN_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });

    handleApiError(error);
  }
};